import { IconDeviceMobile, IconMail, IconMapPin } from "@tabler/icons-react";
import axios from "axios";
import { useState } from "react";

import { toast } from "react-toastify";

const Contact = () => {
  const [name, setName] = useState<string>();
  const [phone, setPhone] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [contents, setContents] = useState<string>();
  const [privacy, setPrivacy] = useState(false);

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !email || !contents) {
      toast.error("이름, 연락처, 주소를 모두 입력해주세요.");
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        email: email,
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          toast.success("문의 등록이 완료되었습니다.", {
            onClose: () => (window.location.href = "/transform"),
          });
        }
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e, {
          onClose: () => (window.location.href = "/"),
        });
      });
  };

  return (
    <>
      {/* {loading && <Loading />} */}
      <div
        id="contact"
        className=" relative w-full h-full px-[calc((100%-var(--container))/2)] py-14 xl:py-28"
      >
        {/* <div id="title" className="text-point text-center lg:text-left">
          <h3>CONTACT US</h3>
        </div> */}
        <div className="/mt-14 relative w-full h-full 2xl:grid grid-cols-3 gap-3">
          <div className="mb-10 2xl:mb-0">
            <div className="leading-8">
              <p>
                <b>Phone</b>
              </p>
              <div className="flex items-center gap-2">
                <IconDeviceMobile />
                <small>061-898-7311</small>
              </div>
            </div>
            <div className="leading-8 mt-5">
              <p>
                <b>E-mail</b>
              </p>
              <div className="flex items-center gap-2">
                <IconMail />
                <small>mini25063@naver.com</small>
              </div>
              <div className="flex items-center gap-2">
                <IconMail />
                <small>obad89@naver.com</small>
              </div>
              <div className="flex items-center gap-2">
                <IconMail />
                <small>bestmakeup2u@gmail.com</small>
              </div>
            </div>
            <div className="leading-8 mt-5">
              <p>
                <b>Address</b>
              </p>

              <div className="flex items-center gap-2">
                <IconMapPin />
                <small>전라남도 진도군 임회면 상만리 236-12</small>
              </div>
              <div className="flex items-center gap-2">
                <IconMapPin />
                <small>전라남도 진도군 고군면 오일시2길 116</small>
              </div>
            </div>
          </div>
          <div className="2xl:col-span-2 relative w-full h-full">
            <div>
              <div className="relative w-full h-full flex gap-3">
                <div id="name-input" className="relative w-full h-full">
                  <label htmlFor="name" className="flex">
                    이름<span className="block text-red-500 ml-1"> *</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="이름을 입력하세요."
                  />
                </div>
                <div id="phone-input" className="relative w-full h-full">
                  <label htmlFor="phone" className="flex">
                    전화번호<span className="block text-red-500 ml-1"> *</span>
                  </label>
                  <input
                    type="text"
                    name="phone"
                    id="phone"
                    pattern="[0-9]+"
                    maxLength={11}
                    value={phone}
                    onChange={(e) =>
                      setPhone(
                        e.target.value
                          .replace(/[^0-9.]/g, "")
                          .replace(/(\..*)\./g, "$1"),
                      )
                    }
                    placeholder="핸드폰 번호를 입력하세요."
                  />
                </div>
              </div>
              <div className="relative w-full h-full flex gap-3 my-5">
                <div id="email-input" className="relative w-full h-full">
                  <label htmlFor="email" className="flex">
                    이메일<span className="block text-red-500 ml-1"> *</span>
                  </label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="이메일을 입력하세요."
                  />
                </div>
                <div className="hidden lg:block relative w-full h-full"></div>
              </div>
              <div className="relative w-full h-full">
                <label htmlFor="contents" className="flex">
                  문의내용<span className="block text-red-500 ml-1"> *</span>
                </label>
                <textarea
                  name="contents"
                  id="contents"
                  value={contents}
                  onChange={(e) => setContents(e.target.value)}
                  placeholder="상담받으실 내용을 입력해주세요."
                ></textarea>
              </div>
              <div className="flex justify-between items-center mt-3">
                <div>
                  <input
                    type="checkbox"
                    name="privacy"
                    id="privacy"
                    onChange={() =>
                      privacy ? setPrivacy(false) : setPrivacy(true)
                    }
                    className="mr-1"
                  />
                  <label htmlFor="privacy">개인정보 수집 동의</label>
                </div>
              </div>
            </div>
            <button
              onClick={handlerPostContact}
              disabled={loading}
              className="w-fit h-fit mx-auto lg:mx-0 my-10 py-2 px-10 text-white rounded-sm bg-point hover:scale-110 transition-all duration-300 cursor-pointer"
            >
              문의 등록
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
